export default __webpack_public_path__ + "static/media/photo--sm--ken-1.f8713b2a.jpg";